window.SmartLightingControl = {
  activateColorVariant(titleHandle, titleName, sku) {
    const activeColorNameSelector =
      '[data-product-dimmer-switch-smart-home-content-color-name]';
    const activeSwatchSelector =
      '[data-product-dimmer-switch-smart-home-content-swatch][data-active=true]';
    const activeImageSelector =
      '[data-product-dimmer-switch-smart-home-content-image][data-active=true]';
    const selectedSwatchSelector = `[data-product-dimmer-switch-smart-home-content-swatch][data-color-swatch-option-value="${titleHandle}"]`;
    const selectedImageSelector = `[data-product-dimmer-switch-smart-home-content-image][data-sku='${sku}']`;

    updateColorName(activeColorNameSelector);
    toggleActiveAttribute(activeSwatchSelector);
    toggleActiveAttribute(activeImageSelector);
    toggleActiveAttribute(selectedSwatchSelector);
    toggleActiveAttribute(selectedImageSelector);

    function toggleActiveAttribute(selector) {
      document.querySelectorAll(selector).forEach((el) => {
        el.setAttribute(
          'data-active',
          String(el.getAttribute('data-active') !== 'true')
        );
      });
    }

    function updateColorName(selector) {
      const colorLabelElement = document.querySelector(selector);

      if (colorLabelElement) {
        colorLabelElement.innerHTML = titleName;
      }
    }
  },
};
